import React from 'react'
import spinner from "assets/gif/Spinner-5.gif"

const CircleSpinner = () => {
    return (
        <span>
            <img src={spinner} alt="circle-spinner" />
        </span>
    );
}

export default CircleSpinner;